import * as React from 'react';
import styled from 'styled-components';
import cl from 'classnames';

import { IconSystemV2EssentialsMoreVerticalAlt } from '@doltech/icons/SystemV2/IconSystemV2EssentialsMoreVerticalAlt';
import { ButtonGeneral } from '@doltech/ui/lib/figma/Button/ButtonGeneral/ButtonGeneral';
import { DolPopover } from '@doltech/ui/lib/figma/Popover/DolPopover';
import { SelectOptionList } from '@doltech/ui/lib/figma/Select/SelectOptionList/SelectOptionList';
import { SelectDropdownItemContent } from '@doltech/ui/lib/figma/Select/SelectDropdownItemContent/SelectDropdownItemContent';
import { DropdownItemItemLayout } from '@doltech/ui/lib/figma/Select/DropdownItemItemLayout/DropdownItemItemLayout';

const DropdownContent = styled.div`
  min-width: 214px;
`;

const Container = styled.div``;

interface ButtonMoreActionsProps {
  className?: string;
  actions?: {
    key?: string;
    text?: string;
    icon?: React.ReactNode;
    onClick?: () => void;
  }[];
}

export const ButtonMoreActions = (props: ButtonMoreActionsProps) => {
  const { className, actions } = props;

  return (
    <Container className={cl('button-more-actions', className)}>
      <DolPopover
        maxWidth="214px"
        className="action-more-tooltip"
        trigger="click"
        placement="bottom-end"
        overlayClassName="un-styled no-arrow custom-inner-content"
        content={
          <DropdownContent>
            <SelectOptionList>
              {actions?.map((singleAction) => {
                const { key, text, icon, onClick } = singleAction;
                return (
                  <DropdownItemItemLayout
                    key={key}
                    content={
                      <SelectDropdownItemContent>
                        <SelectDropdownItemContent.Icon
                          icon={icon}
                        />
                        <SelectDropdownItemContent.Text text={text} />
                      </SelectDropdownItemContent>
                    }
                    onClick={onClick}
                  />
                );
              })}
            </SelectOptionList>
          </DropdownContent>
        }
      >
        <ButtonGeneral
          type="secondary"
          size="large"
          iconLeft={<IconSystemV2EssentialsMoreVerticalAlt />}
          iconOnly
        />
      </DolPopover>
    </Container>
  );
};
